// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Alert = require("../common/Components/Alert.bs.js");
var React = require("react");
var Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
var Next__Image = require("../../reason/next/Next__Image.bs.js");
var ReasonPromise = require("../../reason/ReasonPromise.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var AvatarUploadProvider = require("../../reason/settings/components/AvatarUploadProvider.bs.js");
var FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var SelectProfilePhotoButton = require("../common/ProfilePicture/SelectProfilePhotoButton.bs.js");
var AgentMarketingProfileFeaturedPortraitForm_RemoveMutation_graphql = require("../../__generated__/AgentMarketingProfileFeaturedPortraitForm_RemoveMutation_graphql.bs.js");
var AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql = require("../../__generated__/AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql.bs.js");
var AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile_graphql = require("../../__generated__/AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile_graphql.bs.js");

var convertFragment = AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertVariables = AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql.Internal.convertVariables;

var convertResponse = AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables, AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql.node, convertResponse, convertWrapRawResponse);

var UpdateMutation_imageContentType_decode = AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql.Utils.imageContentType_decode;

var UpdateMutation_imageContentType_fromString = AgentMarketingProfileFeaturedPortraitForm_UpdateMutation_graphql.Utils.imageContentType_fromString;

var UpdateMutation = {
  imageContentType_decode: UpdateMutation_imageContentType_decode,
  imageContentType_fromString: UpdateMutation_imageContentType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

var convertVariables$1 = AgentMarketingProfileFeaturedPortraitForm_RemoveMutation_graphql.Internal.convertVariables;

var convertResponse$1 = AgentMarketingProfileFeaturedPortraitForm_RemoveMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = AgentMarketingProfileFeaturedPortraitForm_RemoveMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, AgentMarketingProfileFeaturedPortraitForm_RemoveMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var use$2 = RescriptRelay_Mutation.useMutation(convertVariables$1, AgentMarketingProfileFeaturedPortraitForm_RemoveMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var RemoveMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$2
};

var acceptedImageTypes = [
  "JPEG",
  "GIF",
  "PNG",
  "WEBP"
];

function parseContentType(contentType) {
  switch (contentType) {
    case "image/gif" :
        return {
                TAG: "Ok",
                _0: "GIF"
              };
    case "image/jpeg" :
        return {
                TAG: "Ok",
                _0: "JPEG"
              };
    case "image/png" :
        return {
                TAG: "Ok",
                _0: "PNG"
              };
    case "image/webp" :
        return {
                TAG: "Ok",
                _0: "WEBP"
              };
    default:
      return {
              TAG: "Error",
              _0: {
                NAME: "UnsupportedMimeType",
                VAL: contentType
              }
            };
  }
}

function getImageDimensions(dataUrl) {
  var match = ReasonPromise.pending();
  var resolve = match[1];
  var img = new Image();
  img.src = dataUrl;
  img.addEventListener("load", (function (param) {
          var width = img.width;
          var height = img.height;
          resolve({
                width: width,
                height: height
              });
        }));
  return match[0];
}

function AgentMarketingProfileFeaturedPortraitForm$WithoutErrorBoundary(props) {
  var marketingProfile = use(props.marketingProfile);
  var match = use$1();
  var runUpdateMutation = match[0];
  var match$1 = use$2();
  var runRemoveMutation = match$1[0];
  var upload = AvatarUploadProvider.useUpload();
  var match$2 = React.useState(function () {
        return "InitialState";
      });
  var setState = match$2[1];
  var state = match$2[0];
  var onSelectProfilePhoto = function (file) {
    setState(function (param) {
          return "Saving";
        });
    var dataUrl = URL.createObjectURL(file);
    var uploadPromise = upload(dataUrl);
    var dimensionsPromise = getImageDimensions(dataUrl);
    ReasonPromise.get(ReasonPromise.all2(uploadPromise, dimensionsPromise), (function (param) {
            var dimensions = param[1];
            var upload = param[0];
            if (upload.TAG === "Ok") {
              var match = upload._0;
              var contentType = parseContentType(match.contentType);
              if (contentType.TAG === "Ok") {
                var contentType$1 = contentType._0;
                runUpdateMutation({
                      input: {
                        featuredPhoto: {
                          contentType: contentType$1 === "PNG" ? "PNG" : (
                              contentType$1 === "JPEG" ? "JPEG" : (
                                  contentType$1 === "WEBP" ? "WEBP" : "GIF"
                                )
                            ),
                          fileName: match.fileName,
                          height: dimensions.height,
                          key: match.key,
                          uploadId: match.id,
                          width: dimensions.width
                        }
                      }
                    }, undefined, undefined, undefined, (function (_response, errors) {
                        if (errors !== undefined) {
                          return setState(function (param) {
                                      return {
                                              TAG: "Error",
                                              _0: "UploadError"
                                            };
                                    });
                        } else {
                          return setState(function (param) {
                                      return "InitialState";
                                    });
                        }
                      }), (function (_error) {
                        setState(function (param) {
                              return {
                                      TAG: "Error",
                                      _0: "UploadError"
                                    };
                            });
                      }), undefined);
              } else {
                var s = contentType._0.VAL;
                setState(function (param) {
                      return {
                              TAG: "Error",
                              _0: {
                                TAG: "UnsupportedMimeType",
                                _0: s
                              }
                            };
                    });
              }
            } else {
              setState(function (param) {
                    return {
                            TAG: "Error",
                            _0: "UploadError"
                          };
                  });
            }
            URL.revokeObjectURL(dataUrl);
          }));
  };
  var onRemovePhoto = function () {
    setState(function (param) {
          return "Saving";
        });
    runRemoveMutation(undefined, undefined, undefined, undefined, (function (_response, errors) {
            if (errors !== undefined) {
              return setState(function (param) {
                          return {
                                  TAG: "Error",
                                  _0: "RemovePhotoError"
                                };
                        });
            } else {
              return setState(function (param) {
                          return "InitialState";
                        });
            }
          }), (function (_error) {
            setState(function (param) {
                  return {
                          TAG: "Error",
                          _0: "RemovePhotoError"
                        };
                });
          }), undefined);
  };
  var tmp;
  var exit = 0;
  if (typeof state !== "object" && state !== "InitialState") {
    tmp = JsxRuntime.jsx(Loader.make, {});
  } else {
    exit = 1;
  }
  if (exit === 1) {
    var tmp$1;
    if (typeof state !== "object") {
      tmp$1 = null;
    } else {
      var tmp$2 = state._0;
      tmp$1 = typeof tmp$2 !== "object" ? (
          tmp$2 === "UploadError" ? JsxRuntime.jsx(Alert.$$Error.make, {
                  title: "There was an error updating your photo. Please try again."
                }) : JsxRuntime.jsx(Alert.$$Error.make, {
                  title: "There was an error removing your photo. Please try again."
                })
        ) : JsxRuntime.jsx(Alert.$$Error.make, {
              title: "The selected photo is not supported. Please try another one."
            });
    }
    var photo = marketingProfile.featuredPhoto;
    tmp = JsxRuntime.jsxs("div", {
          children: [
            tmp$1,
            photo !== undefined ? JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Next__Image.make, {
                            src: photo.url,
                            width: photo.width,
                            height: photo.height,
                            unoptimized: true,
                            alt: "Your current featured portrait",
                            className: "rounded min-w-0"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(SelectProfilePhotoButton.make, {
                                    onSelectProfilePhoto: onSelectProfilePhoto,
                                    acceptedImageTypes: acceptedImageTypes,
                                    children: "Change photo"
                                  }),
                              JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                    onClick: (function (param) {
                                        onRemovePhoto();
                                      }),
                                    size: "small",
                                    children: "Remove photo"
                                  })
                            ],
                            className: "flex flex-col gap-4 items-start md:items-center lg:items-start"
                          })
                    ],
                    className: "flex gap-4 md:items-center lg:items-start md:flex-col lg:flex-row justify-between"
                  }) : JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(SelectProfilePhotoButton.make, {
                          onSelectProfilePhoto: onSelectProfilePhoto,
                          acceptedImageTypes: acceptedImageTypes,
                          children: "Select photo"
                        })
                  })
          ],
          className: "flex flex-col gap-4"
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Form__Label.make, {
                                    labelText: "Featured Portrait"
                                  }),
                              JsxRuntime.jsx("small", {
                                    children: "This is an optional, larger photo that will appear in your marketing profile at full size.",
                                    className: "text-base  text-zinc-500"
                                  })
                            ]
                          }),
                      className: "pt-2 col-span-2"
                    }),
                JsxRuntime.jsx("div", {
                      children: tmp,
                      className: "mt-2 sm:col-span-3 sm:mt-0 "
                    })
              ],
              className: "sm:grid sm:grid-cols-5 sm:items-start gap-16 py-6 space-y-6"
            });
}

var WithoutErrorBoundary = {
  make: AgentMarketingProfileFeaturedPortraitForm$WithoutErrorBoundary
};

function AgentMarketingProfileFeaturedPortraitForm(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "Featured portrait",
              children: JsxRuntime.jsx(AgentMarketingProfileFeaturedPortraitForm$WithoutErrorBoundary, {
                    marketingProfile: props.marketingProfile
                  })
            });
}

var $$Image$1;

var make = AgentMarketingProfileFeaturedPortraitForm;

exports.Fragment = Fragment;
exports.UpdateMutation = UpdateMutation;
exports.RemoveMutation = RemoveMutation;
exports.acceptedImageTypes = acceptedImageTypes;
exports.parseContentType = parseContentType;
exports.$$Image = $$Image$1;
exports.getImageDimensions = getImageDimensions;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* commitMutation Not a pure module */
